module.exports = __webpack_public_path__ + "img/file.6b52468c.svg";